/**
 * Coleta breadcrumbs de navegacao e console errors recentes.
 * Usado por useScreenContext (TASK-2467) para popular metadata de chamado
 * (Report-This-Screen — gap G-N9 do adendo §19).
 *
 * Estado em memoria — nao persiste entre F5 (intencional: pega apenas o
 * contexto recente da sessao corrente).
 */

const MAX_BREADCRUMBS = 10
const MAX_CONSOLE_ERRORS = 5
const MAX_ERROR_MSG_LENGTH = 500

let breadcrumbs: string[] = []
let consoleErrors: string[] = []

export function recordBreadcrumb(path: string): void {
  breadcrumbs.push(path)
  if (breadcrumbs.length > MAX_BREADCRUMBS) breadcrumbs.shift()
}

export function getRecentBreadcrumbs(): string[] {
  return [...breadcrumbs]
}

export function getRecentConsoleErrors(): string[] {
  return [...consoleErrors]
}

/**
 * Reset do estado — uso exclusivo de testes.
 */
export function __resetScreenContextForTests(): void {
  breadcrumbs = []
  consoleErrors = []
  installed = false
}

let installed = false

/**
 * Intercepta console.error globalmente para capturar os ultimos N erros.
 * Idempotente — chamar 1x no main.tsx (bootstrap).
 */
export function installConsoleErrorListener(): void {
  if (installed) return
  installed = true
  const original = console.error
  console.error = (...args: unknown[]) => {
    try {
      const msg = args
        .map((a) => {
          if (typeof a === 'string') return a
          if (a instanceof Error) return a.message
          try {
            return JSON.stringify(a)
          } catch {
            return String(a)
          }
        })
        .join(' ')
      consoleErrors.push(msg.slice(0, MAX_ERROR_MSG_LENGTH))
      if (consoleErrors.length > MAX_CONSOLE_ERRORS) consoleErrors.shift()
    } catch {
      // engolir falhas do listener — nunca quebrar console.error original
    }
    original(...args)
  }
}
